import type { Route } from '@angular/router';

export const ERRORS_ROUTES: Route[] = [
  {
    path: 'error',
    loadComponent: () => import('./components/app-error/app-error.component').then((c) => c.AppErrorComponent),
  },
];
